"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useId = require("../../../hooks/useId");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionSection = function AccordionSection(_ref) {
  var content = _ref.content,
      expanded = _ref.expanded,
      onTitleClick = _ref.onTitleClick,
      sectionKey = _ref.sectionKey,
      setExpanded = _ref.setExpanded,
      title = _ref.title,
      titleElement = _ref.titleElement,
      _ref$headingLevel = _ref.headingLevel,
      headingLevel = _ref$headingLevel === void 0 ? 3 : _ref$headingLevel;
  var sectionId = (0, _useId.useId)();
  var key = sectionKey || sectionId;
  var isExpanded = expanded === key;
  var Title = titleElement || "div";
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "p-accordion__group"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    role: titleElement ? null : "heading",
    "aria-level": titleElement ? null : headingLevel,
    className: "p-accordion__heading"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-controls": "#".concat(sectionId),
    "aria-expanded": isExpanded ? "true" : "false",
    className: "p-accordion__tab",
    onClick: function onClick() {
      if (isExpanded) {
        setExpanded(null, null);
      } else {
        setExpanded(key, title);
      }

      onTitleClick && onTitleClick(!isExpanded, key);
    },
    role: "tab",
    type: "button"
  }, title)), /*#__PURE__*/_react.default.createElement("section", {
    "aria-hidden": isExpanded ? "false" : "true",
    "aria-labelledby": sectionId,
    className: "p-accordion__panel",
    id: sectionId,
    role: "tabpanel"
  }, content));
};

var _default = AccordionSection;
exports.default = _default;